module.exports = __webpack_public_path__ + "img/logo20px.24fdad10.svg";